import { render, staticRenderFns } from "./form-parent.vue?vue&type=template&id=2561ef4a&"
import script from "./form-parent.vue?vue&type=script&lang=js&"
export * from "./form-parent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports